import React from 'react';
import FlyttstadningBase from './flyttstadning-base';

function FlyttstadningIStrangnas() {
  return (
    <FlyttstadningBase
      city="Strängnäs"
      backgroundImage="/images/cleaning/strangnas.webp"
      rubrikOne={`Flyttstädning i Strängnäs med fokus på smidiga och trygga flyttar. Vi är verksamma i både stadskärnan och närliggande områden som Mariefred och Åkers Styckebruk.`}
      rubrikTwo={`Eftersom Strängnäs har många småhus och villor, anpassar vi vår städning efter just din bostad.`}    
      backgroundOpacityClass= "bg-opacity-50"
      />
  );
}

export default FlyttstadningIStrangnas;
